module.exports = __webpack_public_path__ + "img/iphone-install-1.341a511d.jpg";